import { render, staticRenderFns } from "./create-promt.vue?vue&type=template&id=4bf0af8e&scoped=true"
import script from "./create-promt.vue?vue&type=script&lang=js"
export * from "./create-promt.vue?vue&type=script&lang=js"
import style0 from "./create-promt.vue?vue&type=style&index=0&id=4bf0af8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0af8e",
  null
  
)

export default component.exports